import React, {useState} from "react";
import {
  MFAContainer
} from "../styled";
import {setNewToken, validateBackupCode} from "../../actions/authActions";
import {LEFT_ATTEMPTS_FOR_WARN, MAX_CODE_BACKUP_LENGTH, MINIMUM_ATTEMPTS} from "../constants";
import {Button, Form, Message} from "semantic-ui-react";

export const BackUpCodes = ({
  mfaToken,
  redirectPath,
  history,
  dispatch,
  redirectToLogin,
}) => {

  const [mfaBackupCode, setMfaBackupCode] = useState("");
  const [validationErrors, setValidationErrors] = useState(false);
  const [validateMfaCodeError, setValidateMfaCodeError] = useState("");
  const [isMfaProcessing, setIsMfaProcessing] = useState(false);
  const [remainingBackupAttempts, setRemainingBackupAttempts] = useState(null);
  const [disableBtn, setDisableBtn] = useState(true);

  const codeHandler = (e) => {
    setValidationErrors(false);
    setValidateMfaCodeError("");
    setDisableBtn(!e.currentTarget.value.length > 0)
    if (e.currentTarget.value.length > MAX_CODE_BACKUP_LENGTH) return;
    setMfaBackupCode(e.currentTarget.value);
  };


  //Submit code to mfa/login
  const submitCode = async () => {
    setValidateMfaCodeError("");
    setIsMfaProcessing(true);
    if (mfaBackupCode.length < MAX_CODE_BACKUP_LENGTH) {
      setValidationErrors(true);
      setIsMfaProcessing(false);
      return false;
    }

    await validateBackupCode(mfaBackupCode, mfaToken)
      .then(async (response) => {
        dispatch(setNewToken(response.data));
        history.push({ pathname: redirectPath });
      })
      .catch((error) => {
        const { errorMessage, remainingBackupCodeAttempts } =
          error.response.data;
        setIsMfaProcessing(false);
        setValidateMfaCodeError(errorMessage);
        if(remainingBackupCodeAttempts === MINIMUM_ATTEMPTS){
          redirectToLogin(true);
        }
        setRemainingBackupAttempts(remainingBackupCodeAttempts);
      });
  };

  return (
    <>
      <p className={"small"}>
        Enter one of your backup codes to access your account—
      </p>

      {remainingBackupAttempts && (remainingBackupAttempts <= LEFT_ATTEMPTS_FOR_WARN) && (
          <Message negative className={"invalidAttempt smaller"}>
            <b>
              {remainingBackupAttempts}{" "}
              invalid attempt(s) remaining!
            </b>{" "}
            After your <br/>account will be locked for security purposes.{" "}
          </Message>
        )}
      <Form>
        <Form.Field>
          <MFAContainer className="changeMethodField">
            <Form.Input className={'noVerticalMargin'}
              label={"10-digit backup code"}
              type="text"
              name={"backupCode"}
              id={"backupCode"}
              onChange={(e) => codeHandler(e)}
              value={mfaBackupCode}
              maxLength={MAX_CODE_BACKUP_LENGTH}
              required
              error={(validationErrors || !!validateMfaCodeError)}
              disabled={isMfaProcessing}
            />
            {validationErrors && <span className={'warningRedText smaller'}>Enter a 10-digit backup code </span>}
            {validateMfaCodeError && (
              <span className={'warningRedText smaller'}>
                Invalid code, please try again.
              </span>
            )}
          </MFAContainer>

          <Button primary fluid
            loading={isMfaProcessing}
            disabled={isMfaProcessing || disableBtn}
            onClick={submitCode}
          >
            Submit
          </Button>
        </Form.Field>
      </Form>
    </>
  )
}
